import { ImageProps, Image, ImageGroupProps } from "semantic-ui-react";

type BPImageProps = ImageProps & {};

export function BPImage(props: BPImageProps) {
    return <Image {...props}>{props.children}</Image>;
}

type BPImageGroupProps = ImageGroupProps & {};
export function BPImageGroup(props: BPImageGroupProps) {
    return <Image.Group {...props}>{props.children}</Image.Group>;
}